module.exports = __webpack_public_path__ + "static/media/icon_ellipsis-vert.ea3b8b3e.svg";